import { render } from "./VR.vue?vue&type=template&id=8fe62306&scoped=true"
import script from "./VR.vue?vue&type=script&lang=js"
export * from "./VR.vue?vue&type=script&lang=js"

import "./VR.vue?vue&type=style&index=0&id=8fe62306&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8fe62306"

export default script